import {
    Box,
    Container,
    useMediaQuery
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import InfoIcon from "@material-ui/icons/Info";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "../../../component/Header/Header";
import PortalNavbar from "../../../component/PortalNavbar/PortalNavbar";
import { questionListCN } from "./FaqListCN";
import { questionListEN } from "./FaqListEN";
import { questionListTC } from "./FaqListTC";

const useStyles = makeStyles({
    root: {
        width: "85%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
    questionFont: {
        fontWeight: "bold",
    },
    answerPadding: {
        paddingLeft: "23px",
    },
    iconPosition: {
        alignSelf: "flex-start",
        marginTop: "3px",
    },
    
});

const CustomAccordionItem = ({ item }) => {
    const useStyles = makeStyles({
        iconSpan: {
            display: 'inline-flex',
            alignItems: 'center',
        },
        iconBtn: {
            minHeight: "30px",
            margin: "18px 0px 0px 0px",
          },
    });
    const classes = useStyles();
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = () => {
        setIsOpen(!isOpen);
        setExpanded(!expanded);
    };

    const qId = (id) => {
        const desiredLength = 1; // Desired length of the ID
        const paddedId = String(id).padStart(desiredLength, '0');
        return `Q${paddedId}`;
    };

    const aId = (id) => {
        const desiredLength = 1; // Desired length of the ID
        const paddedId = String(id).padStart(desiredLength, '0');
        return `A${paddedId}`;
    };

    const [expanded, setExpanded] = React.useState(false);

    const CustomExpandMoreIcon = ({ expanded }) => {
        return expanded ? <ExpandMoreIcon style={{marginBottom: "20px"}}/> : <ExpandMoreIcon />;
    };

    const showAnswers = (answers) => {
        return (
            <div>
                {answers.map((answer) => (

                    <div 
                         key={answer.number}>   
                      {<div>{answer.title}</div>}          
                        {answer.multiple &&<div>
                        <ul >
                        <li style={{ listStylePosition: 'outside',marginBottom: "10px"}}>
                        {answer.description}
                        {answer.description0 &&<span><br/>{answer.description0}</span>}
                        {answer.CLOHyperlink && <a href={answer.CLOHyperlink} target="_blank" rel="noopener noreferrer" style={{ textUnderlinePosition: "under" }}>{answer.clo}</a>}
                        <br/>{answer.description6}
                        {answer.CLOEfomssHyperlink && <a href={answer.CLOEfomssHyperlink} target="_blank" rel="noopener noreferrer"  style={{ textUnderlinePosition: "under" }}>{answer.link}</a>}
                        {answer.description7}
                        {answer.CLOEfomssHyperlink &&<span>{answer.dot}</span>}
                        {answer.description2}      
                        </li>
                        
                        <li style={{ listStylePosition: 'outside',marginBottom: "10px"}}>
                        {answer.description3}  
                        {answer.SSLOEfomssHyperlink && <a href={answer.SSLOEfomssHyperlink} target="_blank" rel="noopener noreferrer" style={{ textUnderlinePosition: "under" }}>{answer.link}</a> }
                        {answer.description7}
                        {answer.SSLOEfomssHyperlink &&<span>{answer.dot}</span>}
                        </li>
                         
                        
                        <li style={{ listStylePosition: 'outside'}}>
                        {answer.description4}  
                        <a href={answer.PublicEfomssHyperlink} target="_blank" rel="noopener noreferrer" style={{ textUnderlinePosition: "under" }}>{answer.link}</a>
                        {answer.description7}
                        <span>{answer.dot}</span>
                        {answer.description5}  
                        </li>  
                        </ul>
                        </div>}
                        {!answer.multiple &&<div>
                        {answer.description}
                        {answer.description0}
                        {answer.imageSrc &&
                            <InfoIcon style={{fontSize: "inherit", color: "#00000099", verticalAlign: "text-top"}} />
                        }
                        {answer.description2}    
                            </div>}    
                    </div>
                ))}
            </div>
        );
    };

    return (
        
        <div style={{ display: "flex", justifyContent: "center"}}>
        <Accordion style={{width: "94%" ,marginBottom: "10px",borderRadius: "4px"}}
   
           >
            <AccordionSummary
                expandIcon={<CustomExpandMoreIcon expanded={expanded}/>}
                aria-controls={`panel-${item.id}-content`}
                id={`panel-${item.id}-header`}
                onClick={handleClick}
                style={{ cursor: "pointer", width: "100%", alignItems: expanded?"start":"center"}}
                disableGutters={true}
                sx={{
                    "&.Mui-expanded": {
                        minHeight: "30px", 
                        margin: "0px 0px"
                    },
                  }}
            >

                <Table>
        <TableBody>
            <TableRow >
                <TableCell style={{ fontSize: "14px",verticalAlign: "top", fontWeight: "bold", width: "40px",border: "none",padding:"0"}}>
                    <span>{qId(item.id + 1) + ". "}</span>
                </TableCell>
                <TableCell style={{ fontSize: "14px",verticalAlign: "bottom", fontWeight: "bold",border: "none",padding:"0"}}>
                    <p>{item.question}</p>
                </TableCell>
            </TableRow>
            {expanded?
            <div style={{ marginTop: "10px" }}></div>

    :null}    

    {expanded?
            <TableRow >
                <TableCell style={{fontSize: "14px", verticalAlign: "top", width: "40px" ,border: "none",padding:"0"}}>
                    {aId(item.id + 1) + ". "}
                </TableCell>
                <TableCell style={{ fontSize: "14px",verticalAlign: "top",border: "none",padding:"0" }}>
                    <p>{showAnswers(item.answer)}</p>
                </TableCell>
            </TableRow>

    :null}
    </TableBody>
    </Table>

            </AccordionSummary>
            {/* <AccordionDetails style={{  width: "95%", paddingTop: "0px"}}
                             sx={{
                                "&.Mui-expanded": {
                                    margin: "0px 0px 0px 0px",
                                },
                              }}
                              >
            <Table>
        <TableBody>
            <TableRow >
                <TableCell style={{fontSize: "14px", verticalAlign: "top", width: "40px" ,border: "none",padding:"0"}}>
                    {aId(item.id + 1) + ". "}
                </TableCell>
                <TableCell style={{ fontSize: "14px",verticalAlign: "top",border: "none",padding:"0" }}>
                    <p>{showAnswers(item.answer)}</p>
                </TableCell>
            </TableRow>
        </TableBody>
    </Table>
            </AccordionDetails> */}
        </Accordion>
        </div>
    );
};

const language = (language) => {
    
        if (language === "en") {
            return questionListEN.map((item) => (
                <CustomAccordionItem item={item} key={item.id} />
            ));
        } else if (language === "tc") {
            return questionListTC.map((item) => (
                <CustomAccordionItem item={item} key={item.id} />
            ));
        } else if (language === "sc") {
            return questionListCN.map((item) => (
                <CustomAccordionItem item={item} key={item.id} />
            ));
        }   
   
};

function Faq() {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");
    return (
        <Container maxWidth="md">
            <Header headerTitle={t("common.sideNavList.faq")} className="header" />
            <Box className="container">
                <PortalNavbar aside className="drawer" />

                <main className="main" >

                    {/* <Typography variant="subtitle1" style={{ fontWeight: "bold" }} align="center">
                        {t("common.portal.uatNotice")}
                        <br />
                        <br />
                    </Typography> */}
                    {/* {i18n.language === "en"
                        ? questionListEN.map((item) => (
                            <CustomAccordionItem item={item} key={item.id} />
                          ))
                        : i18n.language === "tc"
                        ? questionListTC.map((item) => (
                            <CustomAccordionItem item={item} key={item.id} />
                          ))
                        : questionListCN.map((item) => (
                            <CustomAccordionItem item={item} key={item.id} />
                          ))
                    } */}
                    {language(i18n.language)}
                    
                </main>
            </Box>
        </Container>
    );
}
//     return (
//         <Container maxWidth="md">
//             <Header
//                 headerTitle={t("common.sideNavList.faq")}
//                 className="header"
//             ></Header>
//             <Box className="container">
//                 <PortalNavbar aside className="drawer" />
//                 <main Box className="main">
//                     <Typography
//                         variant="subtitle1"
//                         style={{ fontWeight: "bold" }}
//                         align="center"
//                     >
//                         {t("common.portal.uatNotice")}
//                         <br />
//                         <br />
//                     </Typography>
                                        
//                     <List
//                         component={Paper}
//                         className={matches ? classes.root : classes.rootMobile}
//                     >
//                         {i18n.language === "en"
//                             ? questionListEN.map((item) => (
//                                   <CustomListItem item={item} key={item.id} />
//                               ))
//                             : i18n.language === "tc"
//                             ? questionListTC.map((item) => (
//                                   <CustomListItem item={item} key={item.id} />
//                               ))
//                             : questionListCN.map((item) => (
//                                   <CustomListItem item={item} key={item.id} />
//                               ))}
        
//                     </List>
                    
//                 </main>
//             </Box>
//         </Container>
//     );
// }
export default Faq;
